/**
 * The window which sets a balance.
 *
 * The pencil beside a balance opens it and the button beside the save closes
 * it again. Everything the window does otherwise is a plain form posting to
 * the administration, so a browser without this script - or without
 * `<dialog>` - still has a page which works: the dialog is simply always
 * there, and the pencil is the one thing which is not.
 */

import { query, queryAll } from "../core/dom";

/** Return whether the browser really implements `<dialog>`. */
function dialogsWork(): boolean {
    return typeof HTMLDialogElement === "function" && typeof HTMLDialogElement.prototype.showModal === "function";
}

/** Wire the pencils of the page to the one window which changes a balance. */
export function initGolds(): void {
    const dialog = query<HTMLDialogElement>("[data-gold-dialog]");
    if (!dialog || !dialogsWork()) {
        return;
    }

    for (const pencil of queryAll<HTMLElement>("[data-gold-open]")) {
        pencil.addEventListener("click", () => {
            dialog.showModal();
            query<HTMLInputElement>("input[name=balance]", dialog)?.select();
        });
    }

    dialog.addEventListener("click", (event: Event) => {
        const target = event.target;
        if (target instanceof Element && target.closest("[data-gold-cancel]")) {
            event.preventDefault();
            dialog.close();
        }
    });
}
